import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'image-preview-modal',
    templateUrl: 'image-preview-modal.component.html',
    styleUrls: ['image-preview-modal.component.scss'],
})
export class ImagePreviewModalComponent {
    constructor(
        public dialogRef: MatDialogRef<ImagePreviewModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string }
    ) {}

    closeModal(): void {
        this.dialogRef.close();
    }
}
